import React, { useState } from "react";
import styles from "../../styles/admin.module.css";
import AdminHeader from "../../components/header";
import AdminSidebar from "../../components/sidebar";
import TableView from "../../components/table_view";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../AxiosInstance";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/delete_modal/delete_modal";
import { queryClient } from "../../../App";
import { formatPrice } from "../../../utils/utils";
import { toast } from "react-toastify";

export default function ComboList() {
  const [rows, setRows] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const navigate = useNavigate();
  const [editingPrice, setEditingPrice] = useState(null);
  const [newPrice, setNewPrice] = useState("");

  const deleteObj = (id) => {
    axiosInstance.delete("product/" + id + "/").then((response) => {
      window.location.reload();
    });
  };

  const editObj = (data) => {
    navigate("/admin/combos/create", { state: data });
  };

  const handlePriceUpdate = (id) => {
    // Optimistic update
    setRows((prevRows) =>
      prevRows.map((item) =>
        item.id === id ? { ...item, price: parseFloat(newPrice) } : item
      )
    );
    setEditingPrice(null);
    setNewPrice("");

    axiosInstance
      .patch(`product/price/${id}/`, { price: newPrice, is_combo: true })
      .then(() => {
        setEditingPrice(null);
        setNewPrice("");
        // queryClient.invalidateQueries({ queryKey: ["tableData-product-list"] });
        queryClient.invalidateQueries({ queryKey: ["tableData-combos-list"] });
        toast.success("Prix mis à jour avec succès");
      })
      .catch((err) => {
        // Rollback on error
        // queryClient.invalidateQueries({ queryKey: ["tableData-product-list"] });
        toast.error("Erreur lors de la mise à jour du prix");
        console.log({ err });
      });
  };

  const cols = [
    { title: "Image", image: { url: "image.image" } },
    { title: "Name", internal: "name", filter: true },
    { title: "Subcategory", internal: "subcategory.name" },
    { title: "Cost", internal: "cost", filter: true },
    {
      title: "Price",
      internal: "price",
      filter: true,
      code: (row, data) => {
        return (
          <div
            style={{ whiteSpace: "nowrap" }}
            className="d-flex align-items-center"
          >
            {editingPrice === row.id ? (
              <div className="d-flex align-items-center">
                <input
                  type="number"
                  className="form-control form-control-sm me-2"
                  style={{ width: "100px" }}
                  value={newPrice}
                  onChange={(e) => setNewPrice(e.target.value)}
                />
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => handlePriceUpdate(row.id)}
                >
                  ✓
                </button>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => {
                    setEditingPrice(null);
                    setNewPrice("");
                  }}
                >
                  ✕
                </button>
              </div>
            ) : (
              <>
                {formatPrice(data)}
                <div
                  role="button"
                  className="ms-2"
                  onClick={() => {
                    setEditingPrice(row.id);
                    setNewPrice(data);
                  }}
                >
                  <FontAwesomeIcon icon={faPenToSquare} color={"#9EA3AC"} />
                </div>
              </>
            )}
          </div>
        );
      },
    },
    { title: "Ngor", internal: "combo_warehouse_quantities.ngor" },
    { title: "Plateau", internal: "combo_warehouse_quantities.plateau" },
    { title: "Point E", internal: "combo_warehouse_quantities.point_e" },
    { title: "Sold", internal: "" },
    {
      title: "Actions",
      internal: "id",
      code: (row, data) => {
        return (
          <div className={"d-flex justify-content-between"}>
            <div role={"button"} onClick={() => editObj(row)}>
              <FontAwesomeIcon icon={faPenToSquare} color={"#9EA3AC"} />
            </div>

            <div
              role={"button"}
              onClick={() => {
                setShowDelete(true);
                setSelectedId(data);
              }}
            >
              <FontAwesomeIcon icon={faTrash} color={"#EF4444"} />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <AdminHeader />
      <AdminSidebar />

      <DeleteModal
        show={showDelete}
        setter={setShowDelete}
        onClick={() => deleteObj(selectedId)}
      />

      <div className={`${styles.container} me-4`}>
        <TableView
          defaultFilters={{ combos: true }}
          title={"combos"}
          fetchUrl={`product`}
          withImport={false}
          cols={cols}
          rows={rows}
          pull={setRows}
          useReactQuery={"combos-list"}
        />
      </div>
    </div>
  );
}
